class GridGallery extends HTMLElement {
	selectors = {
		slider: '[data-js-grid-gallery-slider]',
		slides: '[data-js-grid-gallery-slide]',
		previous: '[data-js-grid-gallery-previous]',
		next: '[data-js-grid-gallery-next]'
	};

	connectedCallback() {
		this.sliderElement = this.querySelector(this.selectors.slider);
		this.slideElements = [...this.querySelectorAll(this.selectors.slides)];
		this.previousElement = this.querySelector(this.selectors.previous);
		this.nextElement = this.querySelector(this.selectors.next);

		this.init();
		document.addEventListener('shopify:section:load', this.onSectionLoad);
		document.addEventListener('shopify:block:select', this.onBlockSelect);
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad);
		document.removeEventListener('shopify:block:select', this.onBlockSelect);
		this.destroy();
	}

	init() {
		if (!this.sliderElement || this.swiper || typeof Swiper === 'undefined') return;

		this.swiper = new Swiper(this.sliderElement, {
			slidesPerView: 1,
			spaceBetween: 16,
			navigation: this.previousElement && this.nextElement ? {
				prevEl: this.previousElement,
				nextEl: this.nextElement
			} : false
		});
	}

	onSectionLoad = (event) => {
		if (event.detail.sectionId === this.dataset.sectionId) this.init();
	};

	onBlockSelect = (event) => {
		if (event.detail.sectionId !== this.dataset.sectionId || !this.swiper) return;

		const selectedIndex = this.slideElements.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
		if (selectedIndex !== -1) this.swiper.slideTo(selectedIndex);
	};

	destroy() {
		this.swiper?.destroy(true, true);
		this.swiper = null;
	}
}

if (!customElements.get('grid-gallery')) customElements.define('grid-gallery', GridGallery);
